import type { DrilldownContext } from './DrilldownBreadCrumb';
import { candidatesToContactsMetricName } from './constants';

export const getDrilldownContext = ({
  context,
}: {
  context: DrilldownContext;
}) => {
  const {
    type,
    metric = '',
    yAxis = '',
    xAxis = '',
    g1Header,
    g2Header,
    tableHeader = '',
    chartValue = '',
    deletedTag = null,
    isG1Deleted = false,
    isG2Deleted = false,
  } = context;

  let metric_name = '';
  let dt_display_name = '';
  let g1_display_name = '';
  let g2_display_name = '';

  // The breadcrumb still DISPLAYS the renamed label (e.g. "New candidates"),
  // but the payload must carry the backend contract names. Map any renamed
  // contacts metric/series label back to its "Contacts" equivalent; unmapped
  // values (dates, source names, other report types) pass through unchanged.
  const toPayloadName = (name) =>
    (name && candidatesToContactsMetricName[name]) || name;

  switch (type) {
    case 'metrics':
      metric_name = metric;
      break;

    case 'chart':
      dt_display_name = xAxis;
      g1_display_name = yAxis;
      if (chartValue) {
        g2_display_name = chartValue;
      }
      break;

    case 'table': {
      const g1Title = g1Header || g1Header?.name || null;
      const g2Title = g2Header || g2Header?.name || null;
      metric_name = tableHeader || metric;
      g1_display_name = g1Title;
      g2_display_name = g2Title;
      break;
    }

    default:
      return null;
  }
  return {
    metric_name: toPayloadName(metric_name),
    dt_display_name,
    g1_display_name: toPayloadName(g1_display_name),
    g2_display_name: toPayloadName(g2_display_name),
    deletedTag,
    isG1Deleted,
    isG2Deleted,
  };
};
